import { render, staticRenderFns } from "./footer.component.vue?vue&type=template&id=91a3b118&scoped=true&"
import script from "./footer.component.ts?vue&type=script&lang=ts&"
export * from "./footer.component.ts?vue&type=script&lang=ts&"
import style0 from "./footer.component.scss?vue&type=style&index=0&id=91a3b118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a3b118",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
